module.exports = __webpack_public_path__ + "src/assets/img/20.d9cf77f8.svg";